import {
  KSendSuccessResponse,
  WorkflowDataDto,
} from '@asset-metrix/portal-gateway-client-js';
import { MutationFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const executeWorkflowAction: MutationFunction<
  KSendSuccessResponse,
  {
    contentId: string;
    action: string;
    data: WorkflowDataDto;
  }
> = async ({ contentId, action, data }) => {
  const response = await portalGatewayClient.workflow.executeWorkflowAction(
    contentId,
    action,
    data
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, `Error executing action ${action}`),
      response
    );
  }

  return response.data;
};
